import { Box, Typography, Paper, Table, TableBody, TableCell, TableContainer, TableHead, TableRow, Tooltip, Stack } from '@mui/material';
import { History } from '@mui/icons-material';
import { useTranslation } from 'react-i18next';
import dayjs from 'dayjs';

export default function CommunicationHistory({ communications }) {
  const { t } = useTranslation();

  if (!communications || communications.length === 0) {
    return null;
  }

  return (
    <Box sx={{ mt: 3 }}>
      <Stack direction="row" alignItems="center" spacing={1} sx={{ mb: 1 }}>
        <History fontSize="small" color="action" />
        <Typography variant="subtitle2" fontWeight="bold" color="text.secondary">
          {t("Communication History")}
        </Typography>
      </Stack>
      <TableContainer component={Paper} variant="outlined">
        <Table size="small">
          <TableHead>
            <TableRow sx={{ bgcolor: 'action.hover' }}>
              <TableCell sx={{ fontWeight: 'bold', width: 150 }}>{t("Date")}</TableCell>
              <TableCell sx={{ fontWeight: 'bold', width: 150 }}>{t("Sent By")}</TableCell>
              <TableCell sx={{ fontWeight: 'bold' }}>{t("Message")}</TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {communications.map((comm) => (
              <TableRow key={comm.id} hover>
                <TableCell>
                  <Typography variant="caption" color="text.secondary">
                    {dayjs(comm.createdAt).format('MMM D, YYYY h:mm A')}
                  </Typography>
                </TableCell>
                <TableCell>
                  <Typography variant="body2">
                    {comm.person?.firstName} {comm.person?.lastName}
                  </Typography>
                </TableCell>
                <TableCell>
                  <Tooltip title={comm.explanation} arrow placement="top-start">
                    <Typography
                      variant="body2"
                      sx={{
                        overflow: 'hidden',
                        textOverflow: 'ellipsis',
                        whiteSpace: 'nowrap',
                        maxWidth: 200,
                        cursor: 'pointer'
                      }}
                    >
                      {comm.explanation}
                    </Typography>
                  </Tooltip>
                </TableCell>
              </TableRow>
            ))}
          </TableBody>
        </Table>
      </TableContainer>
    </Box>
  );
}
